import React, { Component } from 'react'

// import classes from './ReportKpi.scss'
import { updateFilterOptions } from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import FilterModal from '../../../../components/FilterModal/FilterModal'
// import Spinner from '../../../../components/UI/Spinner/Spinner'
import PleaseFilter from '../../../../components/PleaseFilter/PleaseFilter'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import Modal from '../../../../components/UI/Modal/Modal'
import Thailand from '@svg-maps/thailand'
import { SVGMap } from 'react-svg-map'
import classes from './DashboardBranchPerformance.scss'
import Form from '../../../../components/PageContent/Dashboard/DashboardBranchPerformance/Form/Form'
// import 'react-svg-map/lib/index.css'

class DashboardBranchPerformance extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    action: 'add',
    actionRecordId: null,
    formValid: false,
    searchText: '',
    withSeq: true,
    filter: {},
    filterControls: {
      company_id: {
        label: 'company',
        value: '',
        configs: {
          placeholder: 'Select Company',
          options: [{ value: '', label: 'Select Company' }]
        },
        required: true
      },
      form_id: {
        label: 'form',
        value: '',
        configs: {
          placeholder: 'Select Form',
          options: [{ value: '', label: 'Select Form' }]
        },
        required: true
      }
    },
    pointedLocation: null,
    selectLocation: '',
    tooltipStyle: {
      display: 'none'
    },
    data: [
      {
        id: '%เป้าหมาย',
        ranges: [20, 40, 60, 80, 100, 120],
        measures: [81],
        markers: [99]
      }
      // {
      //   id: 'power',
      //   ranges: [0.9091592305719239, 0.3077035542945641, 0.8279355529901551, 0, 2],
      //   measures: [0.54555407983444, 1.7778861906143644],
      //   markers: [1.6771864137329937]
      // }
    ],
    parameters: {},
    updateProps: {
      selectedRecord: this.props.selectedRecord,
      companyOptions: this.props.companyOptions,
      filterCompany: this.props.filterCompany,
      filterForm: this.props.filterForm
      // filterLevelGroup: this.props.filterLevelGroup,
      // filterOrg: this.props.filterOrg,
      // filterPosition: this.props.filterPosition,
      // filterEmp: this.props.filterEmp,
      // filterAppraisalType: this.props.filterAppraisalType
    }
  }

  // componentDidUpdate(prevprops) {
  //   if (prevprops.success !== this.props.success && this.props.success) {
  //     this.clearModal()
  //   }
  // }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state
    const updateFilter = (stateId, propsId, attr) => {
      let [attrId, attrName] = attr

      updatedState = {
        ...updatedState,
        filterControls: {
          ...state.filterControls,
          [stateId]: updateFilterOptions(
            props[propsId],
            state.filterControls[stateId],
            attrId,
            attrId,
            attrName,
            null,
            null,
            state.filterControls[stateId].value
          )
        },
        updateProps: {
          ...updateProps,
          [propsId]: props[propsId]
        }
      }
    }
    if (props.companyOptions !== updateProps.companyOptions) {
      updateFilter('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' }
      ])
    }
    if (props.filterForm !== updateProps.filterForm) {
      updateFilter('form_id', 'filterForm', ['form_id', 'form_name'])
    }
    return updatedState
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data

      return (filterControls = {
        ...filterControls,
        [datakey]: { ...filterControls[datakey], value: '' }
      })
    })
    this.props.fetchFilter()
    this.props.clearReportKpi()
    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      filter: []
    })
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls
    if (itemKey === 'company_id') {
      this.props.fetchFormOptions({ company_id: filterValue.value })
    }

    this.setState({
      filterControls: {
        ...this.state.filterControls,
        [itemKey]: {
          ...filterItem[itemKey],
          value: filterValue
        }
      },
      filter: {
        ...this.state.filter
      }
    })
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    let filter = {
      ...this.state.filter
    }
    let parameters = {}
    Object.entries(filter).map(form => {
      let [key, formAttrs] = form

      if (formAttrs !== undefined) {
        parameters = {
          ...parameters,
          [key]: formAttrs
        }
      }
      return form
    })
    this.props.dashboardBranchPerformance(parameters)
    this.setState({
      openPreview: true,
      parameters: parameters
    })
    this.closeFilterModal()
  }

  openModal = () => {
    this.setState({
      modalOpen: true
    })
  }

  closeModal = () => {
    this.clearModal()

    this.setState({
      modalOpen: false
    })
  }
  clearModal = () => {
    this.setState({
      modalOpen: false
    })
  }

  handleLocationMouseOver = event => {
    this.setState({ pointedLocation: event.target.getAttribute('name') })
    // const pointedLocation = getLocationName(event);
    // this.setState({ pointedLocation: pointedLocation });
  }

  handleLocationMouseOut = () => {
    this.setState({ pointedLocation: null, tooltipStyle: { display: 'none' } })
  }

  handleLocationMouseMove = event => {
    const tooltipStyle = {
      display: 'block',
      top: event.clientY + 10,
      left: event.clientX - 100
    }
    this.setState({ tooltipStyle: tooltipStyle })
  }

  // handleLocationFocus(event) {
  //   // const focusedLocation = getLocationName(event)
  //   // this.setState({ focusedLocation: focusedLocation })
  // }

  // handleLocationBlur() {
  //   this.setState({ focusedLocation: null })
  // }

  // handleOnChange(selectedNode) {
  //   this.setState(prevState => {
  //     return {
  //       ...prevState,
  //       selectedLocation: selectedNode.attributes.name.value
  //     }
  //   })
  // }

  handleLocationClick = event => {
    let check = false
    this.props.province.map(item => {
      if (event.target.getAttribute('name') === item.province_name_eng) {
        check = true
      }
      return item
    })
    if (check) {
      this.setState({
        selectLocation: event.target.getAttribute('name')
      })
      this.props.dashboardBranchPerformanceDetail({
        ...this.state.parameters,
        province_name: this.state.pointedLocation
      })
      this.openModal()
    }
  }

  getLocationClassName = (location, index) => {
    let checkProvinceColor = false
    this.props.province.map(item => {
      if (location.name === item.province_name_eng) {
        checkProvinceColor = true
      }
      return item
    })

    if (checkProvinceColor) {
      return classes['svg-map__location--Chanthaburi']
    } else {
      return classes['svg-map__location']
    }
  }

  checkAvg() {
    let checkProvinceAvg = 0.0
    this.props.province.map(item => {
      if (this.state.pointedLocation === item.province_name_eng) {
        checkProvinceAvg = item.avg
      }
      return item
    })

    return `${this.state.pointedLocation},Avg: ${checkProvinceAvg}`
  }

  render() {
    let map = <PleaseFilter></PleaseFilter>
    if (this.props.province.length !== 0) {
      map = (
        <div>
          <div className={classes.examples}></div>
          <SVGMap
            map={Thailand}
            className={classes.examples__block__map}
            locationClassName={this.getLocationClassName}
            onLocationMouseOver={event => this.handleLocationMouseOver(event)}
            onLocationMouseOut={this.handleLocationMouseOut}
            onLocationMouseMove={event => this.handleLocationMouseMove(event)}
            onLocationClick={event => this.handleLocationClick(event)}
          />
          <div className={classes.examples__block__map__tooltip} style={this.state.tooltipStyle}>
            {this.checkAvg()}
          </div>
        </div>
      )
    }

    return (
      <Aux>
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
          loadingQueue={this.props.loadingStates}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={`ประสิทธิภาพของสาขา: ${this.state.selectLocation}`}
          backdropClicked={this.closeModal}
          buttonClose
          footer={null}
          size={'md'}>
          <div className={classes.ModalBody}>
            <Form form={this.props.detail} province={this.state.selectLocation} />
          </div>
        </Modal>
        <Card>
          <CardHeader>
            <FilterBar buttonClicked={this.openFilterModal} />
          </CardHeader>
          <CardBody>{map}</CardBody>
        </Card>
      </Aux>
    )
  }
}
const mapStateToProps = state => {
  return {
    companyOptions: state.dashboardBranchPerformance.company,
    filterCompany: state.dashboardBranchPerformance.company,
    filterForm: state.dashboardBranchPerformance.form,
    report: state.reportKpi.report,
    province: state.dashboardBranchPerformance.province,
    detail: state.dashboardBranchPerformance.detail,
    loadingStates: state.dashboardBranchPerformance.loadingStates
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchFilter: () => {
      dispatch(actions.fetchCompanyOptions())
    },
    fetchCompanyOptions: filter => dispatch(actions.fetchCompanyOptions(filter)),
    fetchFormOptions: filter => dispatch(actions.fetchFormOptions(filter)),
    dashboardBranchPerformance: filter => dispatch(actions.dashboardBranchPerformance(filter)),
    dashboardBranchPerformanceDetail: filter =>
      dispatch(actions.dashboardBranchPerformanceDetail(filter)),
    clearReportKpi: () => dispatch(actions.clearReportKpi())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslate(DashboardBranchPerformance))
